var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2 col-sm-4 col-md-4 col-lg-3"},[_c('div',{staticClass:"text-left",class:[_vm.buttonAlignmentClass]},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"lead color-black btn btn-sm btn-outline-dark",attrs:{"type":"button"}},[_vm._v(_vm._s(_vm.item.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }